{
	"altAfter": "After",
	"altBefore": "Before",
	"ariaCloseCompareView": "Close Compare View",
	"ariaNextComparePhoto": "Next Compare Photo",
	"ariaPreviousComparePhoto": "Previous Compare Photo",
	"unableToLoad": "Unable to load images. Please try again later."
}
